import BaseApi from './baseApi';
import IRPTParameters from '../models/IRPTParameters';
import IAuthentication from '../models/IAuthentication';
export default class RPTParametersApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Reports");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetRPTParameters() : Promise<IRPTParameters[]> {
        const json = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var parameters: IRPTParameters[] = [];
            parameters = response.data as IRPTParameters[];
            return parameters;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveRPTParameters(parameter: IRPTParameters) : Promise<string> {
        const json = this.getJsonSave(parameter);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateRPTParameters(parameter: IRPTParameters) : Promise<boolean> {
        const json = this.getJsonUpdate(parameter);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteRPTParameters(parameterId: string) : Promise<boolean> {
        const json = this.getJsonDelete(parameterId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(idParameter: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "RPT_Parameters",
            "conditions": [{
                "Item1": "RPT_Parameters",
                "Item2": "id",
                "Item3": "=",
                "Item4": idParameter
            }]
        };
        return json;
    }

    private getJsonSave(parameter: IRPTParameters) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "parameterName",
                "Item2": parameter.parameterName
            }, {
                "Item1": "parameterDescription",
                "Item2": parameter.parameterDescription
            }, {
                "Item1": "parameterType",
                "Item2": parameter.parameterType
            }, {
                "Item1": "dataSource",
                "Item2": parameter.dataSource
            }, {
                "Item1": "valueMember",
                "Item2": parameter.valueMember
            }, {
                "Item1": "displayMember",
                "Item2": parameter.displayMember
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "RPT_Parameters"
        };
        return json;
    }

    private getJsonUpdate(parameter: IRPTParameters) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "parameterName",
                "Item2": parameter.parameterName
            }, {
                "Item1": "parameterDescription",
                "Item2": parameter.parameterDescription
            }, {
                "Item1": "parameterType",
                "Item2": parameter.parameterType
            }, {
                "Item1": "dataSource",
                "Item2": parameter.dataSource
            }, {
                "Item1": "valueMember",
                "Item2": parameter.valueMember
            }, {
                "Item1": "displayMember",
                "Item2": parameter.displayMember
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "RPT_Parameters",
            "keyvalue": parameter.id
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "RPT_Parameters",
                "Item2": "id"
            }, {
                "Item1": "RPT_Parameters",
                "Item2": "parameterName"
            }, {
                "Item1": "RPT_Parameters",
                "Item2": "parameterDescription"
            }, {
                "Item1": "RPT_Parameters",
                "Item2": "parameterType"
            }, {
                "Item1": "RPT_Parameters",
                "Item2": "dataSource"
            }, {
                "Item1": "RPT_Parameters",
                "Item2": "valueMember"
            }, {
                "Item1": "RPT_Parameters",
                "Item2": "displayMember"
            }],
            "tables": [{
                "Item1": "RPT_Parameters"
            }],
            "conditions": [{
                "Item1": "RPT_Parameters",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0"
            }]
        };
        return json;
    }
}
